<template>
    <section class="main-section main-location">
        <v-container class="container--large">
            <div class="tit-wrap">
                <h2 class="tit tit--lg tit--point line-height-1 white--text">
                    <span>
                        {{ lang === "ko" ? "찾아오시는 길" : "Location" }}
                    </span>
                    <span class="ko tit--point__circle" data-aos="zoom-in" />
                </h2>
            </div>
            <v-row>
                <v-col cols="12" md="6" lg="8" class="mb-10px mb-lg-0">
                    <v-img :src="`/images/main/location/map-${lang}.png`" max-width="876" contain class="w-100" />
                </v-col>
                <v-col cols="12" md="6" lg="4" class="border-md-l border-white">
                    <div class="h-100 d-flex align-center">
                        <div class="pl-xl-100px">
                            <div v-for="(item, index) in currentItems" :key="index" class="mb-12px mb-lg-60px" data-aos="fade-up" :data-aos-delay="100 * index">
                                <p class="txt txt--sm font-weight-meidum line-height-1 white--text mb-4px mb-lg-10px">
                                    {{ item.name }}
                                </p>
                                <component :is="item.name === 'Tel' || item.name === 'E-mail' ? 'a' : 'p'" :href="item.name === 'Tel' ? `tel:${item.text}` : item.name === 'E-mail' ? `mailto:${item.text}` : null" class="txt grey--text text--lighten-3" :class="{ 'v-btn--text-underline': item.name === 'Tel' || item.name === 'E-mail' }">
                                    {{ item.text }}
                                </component>
                            </div>
                            <v-row data-aos="fade-up" data-aos-delay="300">
                                <v-col v-for="(item, index) in currentLinks" :key="index" cols="auto">
                                    <a :href="item.link" target="_blank">
                                        <span class="d-sr-only">{{ item.name }}</span>
                                        <i class="icon" :class="item.name == 'Kakao Map' ? 'icon-kakaomap' : item.name == 'Naver Map' ? 'icon-navermap' : item.name == 'TMAP' ? 'icon-tmap' : item.name == 'Google Maps' ? 'icon-googlemap' : null" />
                                    </a>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    props: {
        lang: { type: String, default: "ko" },
    },
    data() {
        return {
            ko: {
                items: [
                    {
                        name: "Address",
                        text: "서울 강남구 봉은사로 325, 라임타워 13층 (06103)",
                    },
                    {
                        name: "Tel",
                        text: "02-723-6510",
                    },
                    {
                        name: "E-mail",
                        text: "support@sagelaw.co.kr",
                    },
                ],
                links: [
                    {
                        name: "Kakao Map",
                        link: "https://place.map.kakao.com/25014747",
                    },
                    {
                        name: "Naver Map",
                        link: "https://naver.me/FUhLaFJZ",
                    },
                    {
                        name: "TMAP",
                        link: "https://tmap.life/599b1ec8",
                    },
                    {
                        name: "Google Maps",
                        link: "https://maps.app.goo.gl/DK4ATENnewzrKxyn6",
                    },
                ],
            },
            en: {
                items: [
                    {
                        name: "Address",
                        text: "13F, Lime Tower, 325 Bongeunsa-ro, Gangnam-gu, Seoul 06103, Republic of Korea",
                    },
                    {
                        name: "Tel",
                        text: "+82-2-723-6510",
                    },
                    {
                        name: "E-mail",
                        text: "support@sagelaw.co.kr",
                    },
                ],
                links: [
                    {
                        name: "Kakao Map",
                        link: "https://place.map.kakao.com/25014747",
                    },
                    {
                        name: "Naver Map",
                        link: "https://naver.me/FUhLaFJZ",
                    },
                    {
                        name: "TMAP",
                        link: "https://tmap.life/599b1ec8",
                    },
                    {
                        name: "Google Maps",
                        link: "https://www.google.co.kr/maps/place/서울특별시+강남구+봉은사로+325/@37.5101203,127.0398066,17z/data=!3m1!4b1!4m6!3m5!1s0x357ca40984aa78d1:0xbf5ce381b1161880!8m2!3d37.5101161!4d127.0423815!16s%2Fg%2F11tjfdbdy4?hl=en",
                    },
                ],
            },
        };
    },
    computed: {
        currentItems() {
            return this.lang === "ko" ? this.ko.items : this.en.items;
        },
        currentLinks() {
            return this.lang === "ko" ? this.ko.links : this.en.links;
        },
    },
};
</script>

<style lang="scss" scoped>
.main-location {
    background: url(/images/main/location/background.jpg) no-repeat center / cover;
}
</style>